import React from 'react';
import './App.css';

function App() {
    return (
        <div className="App">
            {/* Header */}
            <header className="header">
                <div className="container">
                    <h1 className="name">안송이</h1>
                    <p className="title">Backend Developer</p>
                    <div className="contact">
                        <a href="https://github.com/SSONG22" target="_blank" rel="noopener noreferrer">
                            <span>🔗 GitHub</span>
                        </a>
                        <a href="https://cheering99.tistory.com/" target="_blank" rel="noopener noreferrer">
                            <span>📝 Blog</span>
                        </a>
                        <span>📞 010-5607-0449</span>
                        <span>📧 annna0449@naver.com</span>
                    </div>
                </div>
            </header>

            {/* Introduce */}
            <section className="section introduce">
                <div className="container">
                    <h2 className="section-title">Introduce</h2>
                    <div className="intro-content">
                        <p>
                            안녕하세요, 백엔드 개발자 안송이입니다. </p>
                            <p>
                            1. 늘 '같이 일하고싶은 동료'가 되고싶습니다.
                            </p>
                            <p>
                            2. 안정적으로 운영하기 위한 문서화, 서버 구조에 관심이 많습니다.
                            </p>
                    
                    </div>
                </div>
            </section>

            {/* Work Experience */}
            <section className="section experience">
                <div className="container">
                    <h2 className="section-title">Work Experiences</h2>
                    <div className="timeline">
                        <div className="timeline-item">
                            <div className="timeline-date">2022.06.27 ~ 재직중</div>
                            <div className="timeline-content">
                                <h3>11번가 상품프론트개발팀 백엔드 / 매니저</h3>
                            </div>
                        </div>
                        <div className="timeline-item">
                            <div className="timeline-date">2020.10.08 ~ 2021.11.11</div>
                            <div className="timeline-content">
                                <h3>비바앤에스 개발팀 스마트팜 백엔드 / 주임</h3>
                            </div>
                        </div>
                        <div className="timeline-item">
                            <div className="timeline-date">2020.02.04 ~ 2020.07.31</div>
                            <div className="timeline-content">
                                <h3>워크브레인 강집사 앱 개발 / 전임</h3>
                            </div>
                        </div>
                        <div className="timeline-item">
                            <div className="timeline-date">2018.11.19 ~ 2019.11.25</div>
                            <div className="timeline-content">
                                <h3>제이솔루션 LG 전자 인공지능팀 협력직원 / 사원</h3>
                            </div>
                        </div>
                        <div className="timeline-item">
                            <div className="timeline-date">2017.08 ~ 2017.12</div>
                            <div className="timeline-content">
                                <h3>한국의학연구소(KMI) 전산실 운영팀 / 인턴</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Skills */}
            <section className="section skills">
                <div className="container">
                    <h2 className="section-title">Skill Set</h2>
                    <div className="skills-grid">
                        <div className="skill-category">
                            <h3>Backend</h3>
                            <div className="skill-tags">
                                <span className="skill-tag">Java (8, 11, 17, 21)</span>
                                <span className="skill-tag">Spring Boot (2.x ~ 3.x)</span>
                                <span className="skill-tag">Spring Framework 5</span>
                                <span className="skill-tag">JPA</span>
                                <span className="skill-tag">MyBatis</span>
                                <span className="skill-tag">QueryDSL</span>
                                <span className="skill-tag">Testcontainers</span>
                            </div>
                        </div>
                        <div className="skill-category">
                            <h3>Data</h3>
                            <div className="skill-tags">
                                <span className="skill-tag">MySQL</span>
                                <span className="skill-tag">MariaDB</span>
                                <span className="skill-tag">Oracle</span>
                                <span className="skill-tag">Redis</span>
                                <span className="skill-tag">Elasticsearch</span>
                                <span className="skill-tag">MongoDB</span>
                                <span className="skill-tag">InfluxDB</span>
                            </div>
                        </div>
                        <div className="skill-category">
                            <h3>Messaging / Infra</h3>
                            <div className="skill-tags">
                                <span className="skill-tag">Kafka</span>
                                <span className="skill-tag">RabbitMQ</span>
                                <span className="skill-tag">Docker</span>
                                <span className="skill-tag">AWS</span>
                                <span className="skill-tag">Nginx</span>
                                <span className="skill-tag">Swagger</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Projects */}
            <section className="section projects">
                <div className="container">
                    <h2 className="section-title">Projects</h2>

                    <div className="project-card">
                        <div className="project-header">
                            <h3>상품상세·리뷰(PDP) 서버 운영 및 개발</h3>
                            <span className="project-period">11번가 (2025.04 ~)</span>
                        </div>
                        <div className="tech-stack">
                            Java 17, Spring Boot 2.7 ~ 3.2, Oracle, JPA, MyBatis, Redis, Elasticsearch
                        </div>
                        <ul className="project-details">
                            <li>기존 상품상세 도메인 구조를 분석하고 영향 범위를 최소화하는 방식으로 신규 API 설계·확장</li>
                            <li>가격비교 프로모션 서비스 개발로 바로구매 전환율 상승에 기여</li>
                            <li>복잡한 요구사항을 기술 요구사항으로 정리하고 운영/장애 대응까지 참고 가능한 수준으로 문서화</li>
                            <li>리뷰 조회 성능 개선을 위한 Elasticsearch 도입 설계 및 마이그레이션 진행</li>
                        </ul>
                    </div>

                    <div className="project-card">
                        <div className="project-header">
                            <h3>숏폼(11play) 서버 개발</h3>
                            <span className="project-period">11번가 (2024.08 ~)</span>
                        </div>
                        <div className="tech-stack">
                            Java 21, Spring Boot 3.2.1, MariaDB, JPA, Docker, Redis
                        </div>
                        <ul className="project-details">
                            <li>11번가 회원이 숏폼 영상을 업로드하고 구매자는 짧은 영상으로 쇼핑 정보를 얻는 서비스</li>
                            <li>외부 숏폼 플랫폼 의존 구조 → 자체 숏폼 서버 설계·개발로 운영 비용 절감에 기여</li>
                            <li>확장 가능한 아키텍처 설계(트래픽 많은 public / 상대적으로 적은 private 분리, 외부/내부 API 역할 분리)</li>
                            <li>조회 중심 데이터 모델링 + 커서 기반 페이징 적용으로 고트래픽 환경에서 안정적 목록 조회 성능 확보</li>
                        </ul>
                    </div>

                    <div className="project-card">
                        <div className="project-header">
                            <h3>앱테크형 게임 시즌2(11키티즈) 서버 개발</h3>
                            <span className="project-period">11번가 (2024.08 ~ 2025.04)</span>
                        </div>
                        <div className="tech-stack">
                            Java 21, Spring Boot 3.2.1, MariaDB, JPA, Docker, Redis, Testcontainers
                        </div>
                        <ul className="project-details">
                            <li>보상 기반의 앱테크형 게임으로 앱 사용률 증가를 목표로 한 서비스</li>
                            <li>엣지 케이스까지 점검하기 위해 테스트 코드를 필수로 작성하고 Testcontainers로 인수 테스트 코드 구성</li>
                            <li>20개 이상의 API Spec 정의 및 FE와 커뮤니케이션으로 짧은 일정 내 개발 완료</li>
                            <li>원활한 QA를 위해 Cheat API 제공 및 Swagger로 공유</li>
                        </ul>
                    </div>

                    <div className="project-card">
                        <div className="project-header">
                            <h3>채팅 서비스(11톡) 서버 구조 개선</h3>
                            <span className="project-period">11번가 (2023.01.02 ~ 2024.04.06)</span>
                        </div>
                        <div className="tech-stack">
                            Java (사내 표준 기반), Spring Boot, Kafka, Redis
                        </div>
                        <ul className="project-details">
                            <li>유지보수 난이도가 높았던 Node.js 프로젝트를 Fade-out하여 운영이 쉬운 구조로 개선</li>
                            <li>메시지 데이터 흐름을 순환 구조 → 단방향으로 단순화해 디버깅/장애 대응 용이</li>
                            <li>비즈니스 로직/성능을 고려해 Message Queue를 RabbitMQ → Kafka로 전환, 발송 속도 2.5배 개선</li>
                            <li>메시지 템플릿/디자인 요소를 정리해 메시지 1건당 DB 저장 크기 73% 절감</li>
                        </ul>
                    </div>

                    <div className="project-card">
                        <div className="project-header">
                            <h3>채팅 서비스(11톡) 서버 운영</h3>
                            <span className="project-period">11번가 (2022.06.27 ~)</span>
                        </div>
                        <div className="tech-stack">
                            Java (11, 17), Spring Boot (2.2.7, 3.0.5), MySQL, MyBatis, JPA, QueryDSL, Kafka, Redis
                        </div>
                        <ul className="project-details">
                            <li>고객-셀러 1:1 채팅 및 광고/알림 메시지 대량 발송을 제공하는 서비스 운영</li>
                            <li>대량 발송 시 메시지 유실 문제를 해결하여 메시지 발송 실패 건수를 0으로 개선</li>
                            <li>장애 대응을 위한 모니터링/이슈 문서화로 안정적 운영에 기여</li>
                        </ul>
                    </div>

                    <div className="project-card">
                        <div className="project-header">
                            <h3>스마트팜 웹 서버 운영/개발</h3>
                            <span className="project-period">비바앤에스 (2020.10.07 ~ 2021.11.09)</span>
                        </div>
                        <div className="tech-stack">
                            Java 8, Spring framework 5, MariaDB, Docker, Nginx, InfluxDB
                        </div>
                        <ul className="project-details">
                            <li>프로젝트 소개: 다양한 농가에 ICT를 접목시켜 원격으로 작물을 생육환경을 적정하게 유지하고 관리할 수 있도록 서비스를 제공합니다.</li>
                            <li>스마트팜 웹 서버 운영 및 API 개발</li>
                            <li>데이터 타입이 맞는 DB로 변경하여 DB 비용 절감</li>
                        </ul>
                    </div>

                    <div className="project-card">
                        <div className="project-header">
                            <h3>스포츠 NFT 쇼핑몰 서버 개발 (빗썸 테크 아카데미)</h3>
                            <span className="project-period">Virspit (2021.09.21 ~ 2021.10.13)</span>
                        </div>
                        <div className="tech-stack">
                            Java 11, Spring Boot 2.5.4, MariaDB, MongoDB, WebMVC, WebFlux, JPA, AWS, Docker, Swagger
                        </div>
                        <ul className="project-details">
                            <li>프로젝트 소개: 스포츠 관련 NFT 상품을 웹 관리자가 판매, 회원이 구매하는 서비스를 제공합니다.</li>
                            <li>기능별로 서버를 분리(조회와 업데이트 분리)하여 트래픽이 많은 곳에 서버를 효율적으로 관리할 수 있도록 설게 및 개발</li>
                            <li>Feign Client를 사용해 서버간 필요한 정보 통신</li>
                            <li>Kafka 로 Product 데이터를 Consume 하여 업데이트 하도록 구현</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Education */}
            <section className="section education">
                <div className="container">
                    <h2 className="section-title">Education</h2>
                    <div className="education-list">
                        <div className="education-item">
                            <h3>한성대학교 컴퓨터 공학부 졸업</h3>
                            <p>2013.03 ~ 2018.02</p>
                        </div>
                        <div className="education-item">
                            <h3>동국대부속여자고등학교 졸업</h3>
                            <p>2009.03 ~ 2012.03</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Certificate */}
            <section className="section certificate">
                <div className="container">
                    <h2 className="section-title">Certificate</h2>
                    <div className="certificate-item">
                        <span className="badge">🏆 정보처리기사</span>
                        <span className="date">2017.5.26</span>
                    </div>
                </div>
            </section>

            {/* Activity */}
            <section className="section activity">
                <div className="container">
                    <h2 className="section-title">Activity</h2>
                    <div className="activity-list">
                        <div className="activity-item">
                            <span className="period">2021.11 ~ 2021.12</span>
                            <span>next-step TDD&CleanCode 13기 리뷰어</span>
                        </div>
                        <div className="activity-item">
                            <span className="period">2021.08.16 ~ 2021.10.8</span>
                            <span>빗썸 테크 아카데미 교육생</span>
                        </div>
                        <div className="activity-item">
                            <span className="period">2021.07 ~ 2021.09</span>
                            <span>next-step TDD&CleanCode 12기 교육생</span>
                        </div>
                        <div className="activity-item">
                            <span className="period">2019.10 ~ 2019.12</span>
                            <span>Groom 데벨업 시즌1 수료</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="footer">
                <div className="container">
                    <p>© 2025 안송이 Portfolio. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
}

export default App;